// @flow

import * as React from 'react'
import linkViewModel from '@vimcar/shared-utils/linkViewModel'
import {
  DocumentTitle,
  HeaderTitle,
  Page,
  ViewSwitches,
  ViewSwitch,
} from '@vimcar/shared-components/components/AppLayout'
import FullscreenMessage from '@vimcar/shared-components/components/FullscreenMessage'

import CreateBooking from '#components/CreateBooking'
import CreateBookingIntro from '#components/CreateBookingIntro'
import WalkthroughWrapper from '#components/WalkthroughWrapper'
import Warning from '#components/Warning'
import i18n from '#utils/i18n'
import mkViewModel, { type ViewModel } from './viewModel'

const tp = i18n.prefix('components.CreateBooking')

type Props = {
  viewModel: ViewModel,
  history: Object,
}

const CreateBookingContainer = ({ viewModel, history }: Props) => {
  const content = viewModel.loadDependencies$.isFailed
    ? <FullscreenMessage text={tp('loading-failed')}/>
    : viewModel.loadDependencies$.isComplete
      ? (
        <React.Fragment>
          {viewModel.showViewSwitches && (
            <ViewSwitches>
              <ViewSwitch
                active={viewModel.isSimplifiedView}
                icon='timer'
                onClick={viewModel.handleClickShowSimplified}
                title={tp('simplified-booking')}
                />
              <ViewSwitch
                active={viewModel.isCalendarView}
                icon='today'
                onClick={viewModel.handleClickShowCalendar}
                title={tp('calendar-booking')}
                />
            </ViewSwitches>
          )}

          <WalkthroughWrapper
            autoStart
            onCallback={viewModel.handleCloseWalkThrough}
            run={viewModel.showWalkthrough}
            walkThroughSteps={viewModel.walkthroughSteps}
            />

          {viewModel.showNoBookableVehiclesWarning && (
            <Warning
              icon='no-car'
              text={(viewModel.userCanManageVehicles
                ? tp('no-vehicles-bookable-admin-text')
                : tp('no-vehicles-bookable-text'))}
              title={tp('no-vehicles-bookable-title')}
              />
          )}

          {viewModel.showIntro && (
            <CreateBookingIntro
              onSubmit={viewModel.handleIntroSubmit}
              />
          )}

          {viewModel.showCreateBooking && (
            <CreateBooking
              history={history}
              onSetCalendarView={viewModel.handleSetCalendarView}
              toggleViewWalkThroughSeen={viewModel.walkThroughSeen}
              view={viewModel.view}
              />
          )}
        </React.Fragment>
      )
      : null

  return viewModel.isKioskMode === false
    ? (
      <React.Fragment>
        <DocumentTitle>{viewModel.title} | Vimcar</DocumentTitle>
        <HeaderTitle>{viewModel.title}</HeaderTitle>
        <Page loading={viewModel.loadDependencies$.isPending}>
          {content}
        </Page>
      </React.Fragment>
    )
    : content
}

export default linkViewModel<Props, ViewModel>(
  mkViewModel,
  CreateBookingContainer
)
